import { z } from 'zod';
/**
 * `POST /v1/admin/doers/:doerId/devices/:deviceId/unrevoke` body. Now that
 * revocation is sticky, un-revoke is the only path back from "device
 * disowned" — a reason is required so `audit_log` records why, mirroring
 * the onboarding-override pattern (`OverrideReasonSchema` in
 * `validation/onboarding.ts`) rather than the hardcoded literal this route
 * used before.
 */
export const AdminDeviceUnrevokeBodySchema = z
    .object({
    reason: z
        .string()
        .trim()
        .min(3, 'Give a reason (at least 3 characters) — it is recorded in the audit log')
        .max(500),
})
    .strict();
//# sourceMappingURL=admin-device-registry.js.map